import { ActionReducerMapBuilder, PayloadAction } from "@reduxjs/toolkit";
import { fetchRemainsCart } from "../../api/thunks";
import { CartProductType, CartSliceState } from "../types";

export const addRemainsExtraReducers = (
  builder: ActionReducerMapBuilder<CartSliceState>,
) => {
  builder.addCase(fetchRemainsCart.pending, (state) => {
    state.error = null;
    state.isLoadingRemain = true;
  });
  builder.addCase(
    fetchRemainsCart.fulfilled,
    (
      state,
      action: PayloadAction<
        { items: CartProductType[]; totalCount: number } | undefined
      >,
    ) => {
      if (!action.payload) return;

      const filteredProducts = action.payload?.items
        .map((product) => ({
          ...product,
          basketFilials: product.basketFilials.filter(
            (bf) =>
              bf.quantity > 0 || (!bf.quantity && !product.remainQuantity),
          ),
        }))
        .filter((product) => product.basketFilials.length > 0);

      const { ids, totalRemainsCount, basketIds, filialIds } =
        filteredProducts.reduce(
          (
            acc: {
              ids: string[];
              totalRemainsCount: number;
              basketIds: string[];
              filialIds: string[];
            },
            product,
          ) => {
            acc.ids.push(product.vendorId);
            const prodQty = product.basketFilials.reduce(
              (sum, bf) => sum + bf.quantity,
              0,
            );
            acc.totalRemainsCount += prodQty;
            product.basketFilials.forEach((bf) =>
              acc.basketIds.push(bf.basketId),
            );
            const filials = [
              ...new Set([
                ...acc.filialIds,
                ...product.basketFilials.map((bf) => bf.dealerId),
              ]),
            ];
            acc.filialIds = filials;
            return acc;
          },
          { ids: [], totalRemainsCount: 0, basketIds: [], filialIds: [] },
        );

      state.allRemainsIds = ids;
      state.totalRemainsCount = totalRemainsCount;
      if (totalRemainsCount) {
        state.canCreateOrder = true;
      }
      state.allBasketRemainsIds = basketIds;
      state.allFilialsRemainsIds = filialIds;
      state.remainsItems = filteredProducts;
      state.remainsTotalPageNumber = action.payload.totalCount;
      state.isLoadingRemain = false;
    },
  );
  builder.addCase(fetchRemainsCart.rejected, (state, action) => {
    if (!action.meta.aborted) {
      state.error = action.payload;
      state.isLoadingRemain = false;
    }
  });
};
